// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"b2fe539d","903":"6315f363","959":"8fac76e7"}[chunkId] + ".chunk.js";
};